import { Account } from "../entity/Account";
import { SavingsInfo } from "./SavingsInfo";

export class AccountData {
    id: number;
    accountName: string;
    account: Account;
    inBuyOffer: boolean;
    hasFullConsumption: boolean;
    savings: SavingsInfo;
}